// ── BUNDLE INCENTIVE: THE REP'S CALL (opt-in, 2026-11-02) ───────────────
//
// The bundle (Dual 5% / Triple 10% / Full Stack 15% off the visualization
// subtotal, by how many experience modules are active) used to land on every
// quote automatically. It is now the rep's first discount up their sleeve:
// the calculator says the quote QUALIFIES and offers an Apply control; the
// discount only reaches the totals, the web proposal and the PDF once the rep
// applies it. Stored on `inputs.bundleApplied` (true / false).
//
// Two figures ride on the calc:
//   • bundleOffer — what the module count qualifies for (evaluateBundle()).
//                   Internal only: drives the "available" card and nudge.
//   • bundle      — what is actually on the quote. Not applied = the offer
//                   zeroed (tier 0, no label, 0%), so every surface that gates
//                   on `bundle.tier` / `bundleSavings > 0` drops its line with
//                   no change of its own. Applied = the offer, as before.
// Applied follows the tier: a quote that grows from Dual to Triple after the
// rep applied the bundle gets the Triple rate, as it always did.
//
// NO RE-PRICING OF OLD QUOTES. A quote saved before this carries no flag and
// was priced with the bundle on, so a missing flag reads as applied. Every
// save from here on writes the boolean, and a brand-new quote starts at
// NEW_QUOTE_BUNDLE_APPLIED. A duplicate copies `inputs` whole, so it keeps the
// source's setting (or its absence, which still reads as applied).
//
// GUARDRAILS (Pricing Admin 8C) never measure the bundle: line guardrails
// compare a hand-set line to its own rate-card price (pre-bundle), and the
// additional-discount guardrail is measured on the post-bundle one-time
// scope. The bundle is the pre-approved first lever, so applying it can never
// raise a "Needs approval" badge; anything the rep gives beyond it is judged
// on what is left after it.

export const NEW_QUOTE_BUNDLE_APPLIED = false;

/** The rep's choice as saved on a quote's inputs. Absent (every quote saved
 *  before the opt-in) = applied, exactly as it was priced. */
export function savedBundleApplied(inputs) {
  const v = (inputs || {}).bundleApplied;
  if (v === undefined || v === null) return true;
  return v === true;
}

/** The bundle actually on the quote, given what it qualifies for. */
export function appliedBundle(offer, applied) {
  const o = offer || { tier: 0, label: null, pct: 0 };
  if (applied) return o;
  return { ...o, tier: 0, label: null, pct: 0 };
}

/** What applying the qualified bundle would take off a visualization gross. */
export function bundleOfferSavings(offer, vizGross) {
  const pct = Number(offer?.pct) || 0;
  if (!(offer?.tier > 0) || pct <= 0) return 0;
  return Math.round((Number(vizGross) || 0) * (pct / 100));
}

/** Rep-facing "available" line, or "" when the quote qualifies for nothing. */
export function bundleOfferCopy(offer) {
  if (!(offer?.tier > 0) || !offer.label) return "";
  return `${offer.label} available: ${offer.pct}% off visualization`;
}
